import { Modal } from "antd";
import React, { useState } from "react";
import FooterModal from "ui/components/Button/FooterModal";
import Toolbar from "ui/components/Toolbar";
import ButtonAnexarArquivos from "ui/components/Button/ButtonAnexarArquivos";
import { Alert, AlertIcon } from "@chakra-ui/react";

interface ModalModificarAnexoProps {
  isOpen: boolean;
  onClose: () => any;
  onSubmit: (file: File) => any;
  isLoadingSave: boolean;
  mimetype?: string;
}

function ModalModificarAnexo({
  isOpen,
  onClose,
  onSubmit,
  isLoadingSave,
  mimetype,
}: ModalModificarAnexoProps) {
  const [file, setFile] = useState<File | undefined>();

  return (
    <Modal
      destroyOnClose
      width="400px"
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onSubmit={() => {
            if (file) {
              onSubmit(file);
            }
          }}
          onClose={() => {
            onClose();
          }}
          isLoadingSave={isLoadingSave}
          isDisabled={isLoadingSave || !file}
          showRegisterAnother={false}
          primaryButtonText="Salvar"
        />
      }
      centered
      bodyStyle={{
        height: "fit-content",
        overflow: "auto",
        padding: 16,
        borderRadius: 16,
      }}
      className="antd-custom-header"
      title={
        <Toolbar
          title="Modificar arquivo do anexo"
          onClose={onClose}
          alignItems="center"
        />
      }
      visible={isOpen}
      onCancel={onClose}
      closable={false}
    >
      <Alert status="info" mb={4} fontSize={12}>
        <AlertIcon />
        Pode levar até um minuto para a alteração do arquivo ser concluida após
        salvar com sucesso.
      </Alert>
      <ButtonAnexarArquivos
        variant="outline"
        multiple={false}
        accept={mimetype}
        buttonText="Escolher arquivo"
        currentFilesLength={file ? 1 : 0}
        fileName={file?.name}
        onAnexar={(files) => {
          if (files?.length) {
            setFile(files[0]);
          }
        }}
      />
    </Modal>
  );
}

export default ModalModificarAnexo;
